"use client";

import HeaderBackground from "@/components/ui/header-background";
import { FC } from "react";
import Breadcrumbs from "@/components/entities/breadcrumbs";
import { useTranslations } from "next-intl";
import S from "../../../components/service-header/index.module.scss";

interface IServiceSearchHeader {
  video: string;
}

const ServiceSearchHeader: FC<IServiceSearchHeader> = ({ video }) => {
  const t = useTranslations();

  const breadcrumbs = [{ title: t("home"), url: "/" }];

  return (
    <>
      <HeaderBackground type="video" src={video} />
      <div className={S.headerWrapper}>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <h1 className={S.title}>{t("serviceCenter")}</h1>
      </div>
    </>
  );
};

export default ServiceSearchHeader;
